import { asyncComponent } from "../../helpers/asyncComponent";

export const PopperAsync = asyncComponent({
  module: () => import("./Popper"),
  component: (module) => module.Popper,
});
